import { makeElement } from "../../../common/Utils";

export abstract class AbsSocial {
    protected ElBtn!: HTMLElement;
    abstract name: SocialName;

    constructor(protected ElShareUList: HTMLElement, protected option: ShareOption){

    }

    // init
    protected init(){
        // 버튼 템플릿 만들고
        this.makeElBtn();
        // 이벤트 붙이고
        this.addEvent();
        // Ulist에 버튼 템플릿 붙이기
        this.appendElBtn();
    }

    // 이벤트 붙이기
    abstract addEvent(): void;

    // 템플릿 만들기
    makeElBtn(){
        this.ElBtn = makeElement(`
            <button  data-name=${this.name}>
                ${this.name}
            </button>
        `);
    };

    // 템플릿 붙이기
    appendElBtn() {
        this.ElShareUList.appendChild(this.ElBtn)
    };
}
